import API from "../lib/api";

import { dataURLtoBlob, readUploadFile } from "../helpers";

const path = "index.php/rest/V1/customizer";

export async function getUploadedImages(custID = 1) {
  try {
    const response = await API.get(path + `/list?customerId=${custID}`);
    return response;
  } catch (error) {
    console.error("Error:", error.message);
    return null;
  }
}

export async function uploadImage(file = null) {
  if (!file) return;
  try {
    const newFile =
      file?.type === "application/pdf" ? file : await readUploadFile(file);

    const formData = new FormData();
    formData.append("customerId", 1);
    formData.append("cookieId", null);
    formData.append("file", newFile);

    const response = await API.upload(path + "/upload", formData);

    return response?.data || [];
  } catch (error) {
    console.error("Error:", error.message);
    return null;
  }
}

export async function deleteImage(id = null) {
  if (!id) return;
  try {
    const response = await API.delete(`${path}/delete/${id}`);
    return response.data || null;
  } catch (error) {
    console.error("Error:", error.message);
    return null;
  }
}

export async function uploadBaseImage(baseUrl = null) {
  if (!baseUrl) return;
  try {
    const blob = dataURLtoBlob(baseUrl);
    const file = new File([blob], "image.png", { type: "image/png" });

    const formData = new FormData();

    formData.append("file", file);

    const response = await API.upload(path + "/blobupload", formData);

    return response.data?.[0] || null;
  } catch (error) {
    console.error("Error:", error.message);
    return null;
  }
}
